import '../scss/main.scss'

gsap.registerPlugin(ScrollTrigger)

import { Accordion } from './commons/accordion.js'
import { CounterAnimation } from './commons/counter.js'
import { Animations } from './commons/animations.js'
import { UserFilter } from './commons/userfilter.js'
import Slider from './commons/slider.js'
import Inview from './commons/inview.js'
import Modal from './commons/modal.js'
import Menu from './commons/menu.js'
import Search from './commons/search.js'
import Ods from './commons/ods.js'
import Pointer from './commons/pointer.js'
import { win, setWin, setVh, setVw, isTouchDevice } from './utils/index.js'


const App = new function () {
	const body = document.body;

	this.init = () => {
		
		// Initial setup
		setWin()
		setVh()
		setVw()
		
		// If is Touch Device
		if (isTouchDevice) document.body.classList.add('is-touch-device')
		window.addEventListener('resize', this.onResize)
		
		// Pointer
		Pointer.init();
		
		// Slider
		Slider.init();
		
		// Accordion //-- Must Be Before Inview Init --//
		Accordion.init();

		// Modal
		Modal.init()

		// Menu
		Menu.init()

		// Search
		Search.init()

		// ODS labels
		Ods.init()

		// Counter Animation
		CounterAnimation.init();

		// User Filter
		UserFilter.init();

		Animations.init();

		// Inview
		Inview.init()

  	}

	this.onResize = () => {
		setWin()
		setVh()
		setVw()
	}

}

window.addEventListener('load', App.init)